/**
 * Color-coded HIPAA status — shown on every tool surface, both states.
 * HIPAA compatibility is the #1 decision factor for clinicians
 * ("can I use patient data in this or not").
 */
export function HipaaBadge({ compliant }: { compliant: boolean }) {
  if (compliant) {
    return (
      <span
        className="badge-hipaa"
        title="HIPAA Compliant: This tool meets HIPAA requirements for patient data protection. Always verify with vendor for your specific use case."
        aria-label="HIPAA Compliant"
        role="status"
      >
        <span className="hipaa-dot hipaa-dot-yes" aria-hidden="true" />
        HIPAA Compliant
      </span>
    );
  }
  return (
    <span
      className="badge-no-hipaa"
      title="Not HIPAA Verified: Do not use this tool with patient data unless you confirm compliance and a BAA with the vendor."
      aria-label="Not HIPAA Verified"
      role="status"
    >
      <span className="hipaa-dot hipaa-dot-no" aria-hidden="true" />
      Not HIPAA Verified
    </span>
  );
}
